<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	import informationItems from './informationItems/index.vue'
	import SceneTemplate from './SceneTemplate/index.vue'
export default {
	
  name: 'Login',
  components: {
	  informationItems,SceneTemplate
  },
  data: function() {
    return {
		headlist: getdata().headlist,
		chooseindex: 0
    };
  },
  created() {
  },
  methods: {
	  forchooseindex(e){
		  console.log(e)
	  	this.chooseindex=e
	  }
  }
};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
